import * as moment from 'moment';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { Store } from '../../store/models/store.model';
import { ReservationStatus } from '../enums/reservation-status.enum';
import { ReservationConfig } from './reservation-config.model';

export class Reservation {
	id: number;
	store: Store;
	quota: number;
	sectorId: number;
	seats: number;
	overbooking: boolean;
	description: string;
	user: CustomerInfo; // cliente consumidor que fez a própria reserva
	reservationDate: Date | string; // "2021-02-15"
	reservationTime: string;
	config: ReservationConfig;
	status: ReservationStatus;
	present: boolean;
	reservationNumber: number;
	noteReject: string;
	employer: Employer;
	customerInfo: CustomerInfo; // estabelecimento que fez a própria reserva

	// Usado durante edição
	oldReservationDate: Date | string;
	oldReservationTime: string;
	oldQuota: number;
	oldSeats: number;

	// auxilia na tela
	customer: CustomerInfo;

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		if (typeof this.reservationDate === 'string') {
			this.reservationDate = moment(this.reservationDate, "YYYY-MM-DD").toDate();
		}
		if (!this.description) {
			this.description = "";
		}

		// Para facilitar as visualizações na tela, seto no objeto auxiliar customer as infos do usuário
		if (this.user) {
			this.customer = this.user;
			if (this.user.phone) {
				if (!this.user.countryPhoneCode || UtilHelper.unmask(this.user.countryPhoneCode) == "55") {
					this.customer.phone = UtilHelper.mask(this.user.phone, this.user.phone.length > 10 ? "(99) 99999-9999" : "(99) 9999-9999");
				}
				this.customer.countryPhoneCode = UtilHelper.unmask(this.user.countryPhoneCode);
			}
		} else if (this.customerInfo) {
			this.customer = this.customerInfo;
			if (this.customerInfo.phone) {
				if (!this.customerInfo.countryPhoneCode || UtilHelper.unmask(this.customerInfo.countryPhoneCode) == "55") {
					this.customer.phone = UtilHelper.mask(this.customerInfo.phone, this.customerInfo.phone.length > 10 ? "(99) 99999-9999" : "(99) 9999-9999");
				}
				this.customer.countryPhoneCode = UtilHelper.unmask(this.customerInfo.countryPhoneCode);
			}
		}
	}

	toJsonCreate(): any {
		const json: any = {
			store: { id: this.store.id },
			quota: this.quota,
			sectorId: this.sectorId,
			seats: this.seats,
			overbooking: this.overbooking,
			description: this.description,
			customerInfo: this.customerInfo,
			reservationDate: moment(this.reservationDate).format("YYYY-MM-DD"),
			reservationTime: this.reservationTime,
			customer: false
		};
		json.customerInfo.phone = UtilHelper.unmask(this.customerInfo.phone);
		return json;
	}

	toJsonUpdate(): any {
		const json: any = {
			id: this.id,
			store: { id: this.store.id },
			quota: this.quota,
			sectorId: this.sectorId,
			seats: this.seats,
			overbooking: this.overbooking,
			description: this.description,
			reservationDate: moment(this.reservationDate).format("YYYY-MM-DD"),
			reservationTime: this.reservationTime,
			customer: false
		};
		if (this.user) {
			json.user = { id: this.user.id };
		} else if (this.customerInfo) {
			json.customerInfo = this.customerInfo;
			json.customerInfo.phone = UtilHelper.unmask(this.customerInfo.phone);
		}
		return json;
	}

	/**
	 * Constrói um objeto ShortReservationReport que retorna no formato
	 * Data: 23/05
	    11:30
	    - 4 reservas com 2 lugares
		- 3 reservas com 4 lugares

		12:00
		- 1 reserva com 2 lugares
		- 5 reservas com 4 lugares
		- 3 reservas com 3 lugares
		....
	 * @param date 
	 * @param reservations 
	 */
	static buildList(date: string, reservations: Array<Reservation>): ShortReservationReport {
		let data: ShortReservationReport = {
			date: date,
			countDescription: "",
			hours: []
		}
		try {
			let countQuota: number = 0;

			for (let res of reservations) {
				const index: number = data.hours.findIndex((h) => h.hour == res.reservationTime);
				// Hora ainda não está na lista
				if (index == -1) {
					data.hours.push({
						hour: res.reservationTime,
						shortReservations: [{
							quota: res.quota,
							count: 1,
							description: `1 reserva com ${res.quota} ${(res.quota == 1 ? 'lugar' : 'lugares')}`
						}]
					})
				} else {
					// Verifica se já existe na lista um item com a quantidade de lugares
					const indexQuota: number = data.hours[index].shortReservations.findIndex((r) => r.quota == res.quota);
					if (indexQuota == -1) {
						data.hours[index].shortReservations.push({
							quota: res.quota,
							count: 1,
							description: `1 reserva com ${res.quota} ${(res.quota == 1 ? 'lugar' : 'lugares')}`
						})
					} else {
						let count = data.hours[index].shortReservations[indexQuota].count + 1;
						data.hours[index].shortReservations[indexQuota].count = count
						data.hours[index].shortReservations[indexQuota].description = `${count} reservas com ${res.quota} ${(res.quota == 1 ? 'lugar' : 'lugares')}`;
					}
				}
				countQuota += res.quota;
			}
			data.countDescription = reservations.length + (reservations.length == 1 ? " reserva" : " reservas")
					+ " (total de " + countQuota + " lugares)";
			console.log(data);
		} catch (error) {
			console.error(error);
		}
		return data;
	}
}

export class Employer {
	id: number;
	name: string;
}

export class CustomerInfo {
	id: number;
	name: string;
	phone: string;
	email: string;
	countryPhoneCode: string;

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		if (!this.countryPhoneCode) {
			this.countryPhoneCode = "55";
		}
	}
}

export interface ShortReservationReport {
	date: string;
	countDescription: string;
	hours: ShortReservationReportHours[]
}

export interface ShortReservationReportHours {
	hour: string;
	shortReservations: ShortReservationReportItem[]
}

export interface ShortReservationReportItem {
	quota: number;
	count: number
	description: string;
}


// WEBPACK FOOTER //
// ./src/app/pages/reservation/models/reservation.model.ts